import { ICustomerCertifications, ICustomerOrders } from "services/customers"
import { formatCurrency } from "utils/intlNumber"
import { formatDate } from "utils/intlDate"


export const ordersColumns = [
    {
        field: 'order_date',
        headerName: 'Order Number',
        render: (data: ICustomerOrders) => `${data.order_number}`
    },
    {
        field: 'order_date',
        headerName: 'Registration Date',
        render: (data: ICustomerOrders) => formatDate(new Date(data.created_at))
    },
    {
        field: 'total_price',
        headerName: 'Total',
        render: (data: ICustomerOrders) => formatCurrency(Number(data.total_price))
    },
]


export const certificationsColumns = [
    {
        field: 'created_at',
        headerName: 'Date',
        render: (data: ICustomerCertifications) => formatDate(new Date(data.created_at))
    },
    {
        field: 'name',
        headerName: 'Name',
        render: (data: ICustomerCertifications) => data.name
    },
    {
        field: 'certification_number',
        headerName: 'Certification Number',
        render: (data: ICustomerCertifications) => data.certification_number
    }
]

export const classesRows = [
    {
        id: 1,
        date: "Jul 8, 2024",
        timeSlot: "8:00AM - 9:00AM",
        classTitle: "BLS Class",
        location: "West Hollywood",
        status: "Open",
        orderNumber: "#1111"
    },
    {
        id: 2,
        date: "Jan 6, 2024",
        timeSlot: "8:00AM - 9:00AM",
        classTitle: "BLS Class",
        location: "West Hollywood",
        status: "Open",
        orderNumber: "#1111"
    },
    {
        id: 3,
        date: "Jul 8, 2024",
        timeSlot: "8:00AM - 9:00AM",
        classTitle: "BLS Class",
        location: "West Hollywood",
        status: "Completed",
        orderNumber: "#2222"
    },
    {
        id: 4,
        date: "Jul 10, 2024",
        timeSlot: "8:00AM - 9:00AM",
        classTitle: "BLS Class",
        location: "West Hollywood",
        status: "Completed",
        orderNumber: "#3333"
    },
    {
        id: 5,
        date: "Jun 23, 2024",
        timeSlot: "8:00AM - 9:00AM",
        classTitle: "BLS Class",
        location: "West Hollywood",
        status: "Open",
        orderNumber: "#4444"
    },
]
